import { render, staticRenderFns } from "./Loan-details.vue?vue&type=template&id=7fade2a4&scoped=true"
import script from "./Loan-details.vue?vue&type=script&lang=js"
export * from "./Loan-details.vue?vue&type=script&lang=js"
import style0 from "./Loan-details.vue?vue&type=style&index=0&id=7fade2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fade2a4",
  null
  
)

export default component.exports